import "./SectionTwoCard.css";

export const SectionTwoCard = ({
  singleCard,
  multyCard,
  imgMultyCard,
  imgSingleCard,
  headerText,
  titleText,
  contentText,
}) => {
  return (
    <div
      className={
        singleCard == true
          ? "single-card-instance-container"
          : "multy-card-instance-container"
      }
    >
      {singleCard && <h5 className="single-card-title1">{headerText}</h5>}
      {multyCard && <img className="multy-card-icon" src={imgMultyCard}></img>}
      <h2
        className={
          singleCard == true ? "card-title2-single" : "card-title2-multy"
        }
      >
        {titleText}
      </h2>
      <p
        className={singleCard == true ? "single-card-text" : "multy-card-text"}
      >
        {contentText}
      </p>
      {singleCard && <img src={imgSingleCard}></img>}
    </div>
  );
};
